import { render, staticRenderFns } from "./CertificadosReporteCapacitaciones.vue?vue&type=template&id=5837f96e&scoped=true"
import script from "./CertificadosReporteCapacitaciones.vue?vue&type=script&lang=js"
export * from "./CertificadosReporteCapacitaciones.vue?vue&type=script&lang=js"
import style0 from "./CertificadosReporteCapacitaciones.vue?vue&type=style&index=0&id=5837f96e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5837f96e",
  null
  
)

export default component.exports